module.exports = __webpack_public_path__ + "img/sti-dest-hanging.3012754d.svg";